import { __makeTemplateObject, __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import classNames from '../../node_modules/classnames/index.js';
import React__default from 'react';
import styled from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { Box } from '../layout/Box.js';
import { Stack } from '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import '../typography/Text.js';
import '../typography/Display.js';
import { Heading } from '../typography/Heading.js';
import '../typography/Label.js';
import { Paragraph } from '../typography/Paragraph.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
import { space } from '../../node_modules/@styled-system/space/dist/index.esm.js';
var StyledInfo = styled(Box)(function (_a) {
  var rightIcon = _a.rightIcon;
  return css({
    cursor: rightIcon ? "pointer" : "auto",
    paddingRight: rightIcon ? undefined : "16px"
  });
}, variant({
  variants: {
    solid: {
      paddingY: "16px",
      borderRadius: "16px",
      border: "base",
      borderColor: "grey.5"
    },
    flat: {}
  }
}), space);
var RightIconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 48px;\n  padding-right: 4px;\n  transition: all 200ms ease-in-out;\n  font-size: 24px;\n  ", "\n  ", ".withHover:hover & {\n    transform: translateX(4px);\n    ", "\n  }\n  * {\n    color: inherit;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 48px;\n  padding-right: 4px;\n  transition: all 200ms ease-in-out;\n  font-size: 24px;\n  ", "\n  ", ".withHover:hover & {\n    transform: translateX(4px);\n    ", "\n  }\n  * {\n    color: inherit;\n  }\n"])), css({
  color: "grey.1"
}), StyledInfo, css({
  color: "textPrimary"
}));
var Info = React__default.forwardRef(function (props, ref) {
  var icon = props.icon,
    iconWidth = props.iconWidth,
    _a = props.iconPlacement,
    iconPlacement = _a === void 0 ? "top" : _a,
    title = props.title,
    description = props.description,
    rightIcon = props.rightIcon,
    variant = props.variant,
    _b = props.withHover,
    withHover = _b === void 0 ? true : _b,
    rest = __rest(props, ["icon", "iconWidth", "iconPlacement", "title", "description", "rightIcon", "variant", "withHover"]);
  return React__default.createElement(StyledInfo, __assign({
    paddingLeft: iconPlacement === "top" ? "16px" : undefined,
    rightIcon: rightIcon,
    variant: variant
  }, rest, {
    className: classNames({
      withHover: withHover
    }),
    ref: ref
  }), React__default.createElement(Stack, {
    direction: "row",
    spacing: "0"
  }, React__default.createElement(Box, {
    flexGrow: 1
  }, React__default.createElement(Stack, {
    direction: iconPlacement === "top" ? "column" : "row",
    spacing: iconPlacement === "top" ? "20px" : "0"
  }, React__default.createElement(Box, {
    marginTop: iconPlacement === "left" ? "2px" : undefined,
    fontSize: "24px",
    minWidth: iconWidth || (variant === "solid" ? "56px" : "48px"),
    textAlign: variant === "flat" || iconPlacement === "top" ? "left" : "center"
  }, icon), React__default.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, React__default.createElement(Stack, {
    direction: "column",
    spacing: "6px",
    align: "center"
  }, React__default.createElement(Heading, {
    size: "sm",
    width: "100%"
  }, title), description && React__default.createElement(Paragraph, {
    size: "sm"
  }, description))))), rightIcon && React__default.createElement(RightIconWrapper, null, rightIcon)));
});
var templateObject_1;
export { Info };